

import axios from "axios";
import jsonp from "jsonp";
import { Loading } from "../../components";

// let host = "//hrservice.58.com";
let host = "//check.58.com";

let jsonpHost = "//employer.58.com";

const MAXTIMEOUT = 9000;

let count = 0; // 请求累加器

const ajax = (url, method = "get", params = {}) => {
  // 首先判断是get请求还是post请求
  let data = method.toLocaleLowerCase() === 'get' ? 'params' : 'data';
  let myAxios = axios({
    url: host + url +"?"+ Math.random(),
    method,
    // timeout: MAXTIMEOUT,
    [data]: params,
  }).then((res) => {
    switch (res.data.code) {
      case "085":
        window.open("//passport.58.com/login/?path=http://check.58.com/uncheck/index/index_pc/&back=now", "_self")
        break;
      case "087":
        count++;
        if(count===1){
          setTimeout(() => {
            alert("您非企业认证用户，请到58同城首页“个人中心-账户设置-认证管理”完成企业认证");
            window.open("https://vip.58.com/vcenter/authcenterpage/?r=0.8760599533515894", "_self");
          }, 0);
        }
        break;
      default:
        return Promise.resolve(res.data);
        break;
    }
  }).catch((err) => {
    console.log(err);
    alert("网络请求失败，请稍后重试！");
    return Promise.reject("网络请求失败，请稍后重试！");
  })

  axios.interceptors.request.use((config) => {
    // console.log("请求前");
    return config;
  })
  axios.interceptors.response.use((response) => {
    // console.log("请求后");
    return response;
  })

  return myAxios;
}

const myjsonp = function (url = '', baseHost = jsonpHost) {
  return new Promise((resolve, reject) => {
    try {
      jsonp(`${baseHost}${url}`, { timeout: MAXTIMEOUT }, function (err, data) {
        if (err) {
          console.error(err.message);
          reject(err);
        } else {
          resolve(data);
        }
      });
    } catch (e) { alert("网络请求失败，请稍后重试！"); console.log(e); }
  });
};

export {
  ajax,
  myjsonp
}